import * as React from 'react';
export const businessSvg = React.forwardRef(function businessSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.998 8.19A2.908 2.908 0 0 0 16 6v-.1c0-.316-.031-.631-.094-.94l-.63-3.12-.003-.012c-.124-.524-.35-1.013-.774-1.36C14.07.118 13.545 0 13 0H3c-.545 0-1.07.119-1.499.468-.425.347-.65.835-.774 1.36l-.003.012-.63 3.12A4.75 4.75 0 0 0 0 5.9V6c0 .88.39 1.65 1.002 2.191A.76.76 0 0 0 1 8.25v5.5A2.25 2.25 0 0 0 3.25 16h9.5A2.25 2.25 0 0 0 15 13.75v-5.5c0-.02 0-.04-.002-.06ZM1.564 5.257l.625-3.095c.081-.336.185-.47.26-.53.072-.059.215-.131.551-.131h2.14l-.22 4.333v.019c0 .908-.754 1.667-1.71 1.667C2.206 7.519 1.5 6.78 1.5 6v-.1c0-.216.021-.432.064-.644Zm4.855.613.222-4.37H9.36l.222 4.37C9.57 6.81 8.84 7.518 8 7.518s-1.572-.707-1.58-1.65Zm4.662-.036L10.86 1.5H13c.336 0 .48.072.55.13.075.062.18.195.26.531l.626 3.095c.043.212.064.428.064.644V6c0 .78-.708 1.519-1.71 1.519-.956 0-1.71-.76-1.71-1.667v-.02Zm1.71 3.186a3.228 3.228 0 0 1-2.445-1.114A3.033 3.033 0 0 1 8 9.019a3.033 3.033 0 0 1-2.347-1.114A3.226 3.226 0 0 1 3.21 9.018c-.242 0-.48-.025-.709-.075V11.5h11V8.943c-.23.05-.467.076-.71.076ZM2.5 13.75V13h11v.75a.75.75 0 0 1-.75.75h-9.5a.75.75 0 0 1-.75-.75Z',
    }),
  );
});
businessSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var business = {
  category: 'icon',
  colorable: true,
  name: 'business',
  svg: businessSvg,
};
